import { useMemo } from 'react';
import { ApiClient, api } from '@/services/api/client';

/**
 * Hook to get a configured API client instance
 */
export const useApiClient = (): ApiClient => {
  return useMemo(() => {
    // Return the pre-configured API client instance
    return api;
  }, []);
};